import { Box, useMediaQuery } from "@prismicio/editor-ui"
import type { ReactNode } from "react"

interface MediaLibraryLayoutProps {
  mediaList: ReactNode
  mediaToolbar: ReactNode
  mediaActions: ReactNode
  sidePane: ReactNode
}

export function MediaLibraryLayout(props: MediaLibraryLayoutProps) {
  const { mediaList, mediaActions, mediaToolbar, sidePane } = props
  const showSidePane = useMediaQuery({ min: "medium" })

  return (
    <Box
      display="grid"
      gridTemplateRows="auto auto 1fr"
      gridTemplateColumns={showSidePane ? "1fr 380px" : "1fr"}
      width="100%"
      height="100%"
    >
      <Box
        position="relative"
        display="grid"
        gap={16}
        gridColumn="1"
        gridRow="1"
        padding={{ right: 16, bottom: 16 }}
      >
        {mediaActions}
        {mediaToolbar}
      </Box>
      <Box position="relative" display="grid" gridColumn="1" gridRow="2 / -1">
        {mediaList}
      </Box>
      {showSidePane && sidePane}
    </Box>
  )
}
